/**
 * 사용자PC 정산 (/u/settlement) — 캐시 입출금 DataTables(서버사이드) + 기간·구분·사유 필터, 엑셀
 * ($j.Pages.Desktop.Settlement / body data-page-name="Settlement")
 */
export default class Settlement {
    initialize() {
        // 모비스크롤 달력
        $('#start_date,#end_date').mobiscroll().datepicker({
            controls: ['calendar'],
            dateFormat: 'YYYY-MM-DD',
            locale: mobiscroll.localeKo,
            buttons: []
        });

        var table = $('#settlementTable').DataTable({
            serverSide: true,        // 서버사이드
            processing: true,
            searching: false,        // 표내 검색 제거
            lengthChange: false,     // 100개씩 보기 선택 제거
            pageLength: 100,
            order: [[0, 'desc']],
            ajax: {
                url: '/u/ajax/settlement/list',
                data: function (d) {
                    d.start_date = $('#start_date').val();
                    d.end_date   = $('#end_date').val();
                    d.wtype      = $('#wtype').val();
                    d.rtype      = $('#rtype').val();
                }
            },
            columnDefs: [
                { targets: [2, 4, 5, 6, 7], orderable: false }  // 오더번호/회원명/회원코드/지사/사유 비정렬
            ],
            language: {
                processing: '불러오는 중...',
                lengthMenu: '_MENU_ 개씩 보기',
                info: '총 _TOTAL_ 건 중 _START_ ~ _END_',
                infoEmpty: '데이터 없음',
                infoFiltered: '',
                zeroRecords: '조회된 내역이 없습니다.',
                emptyTable: '조회된 내역이 없습니다.',
                paginate: { first: '처음', last: '마지막', next: '다음', previous: '이전' }
            },
            initComplete: function () { $('#settleBox').css('visibility', 'visible'); }
        });

        $('#btnSearch').on('click', function () { table.ajax.reload(); });
        $('#wtype,#rtype').on('change', function () { table.ajax.reload(); });
        // 엑셀저장: 직전 ajax 조회 SQL(ExcelRelay::CASH_TX) 재사용
        $('#btnExcel').on('click', function () { location.href = '/excel/cash/transactions'; });
    }
}
